/**
 * MAX AET AI Academy - AI Vibe Lexikon Professional
 * Main Entry Point
 * 
 * @version 3.0.0
 */

import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./styles/max-aet-theme.css";

// Error boundary for production
class ErrorBoundary extends React.Component<
  { children: React.ReactNode },
  { hasError: boolean; error: Error | null }
> {
  constructor(props: { children: React.ReactNode }) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error("MAX AET Error:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="app-loading">
          <div style={{ fontSize: "48px", marginBottom: "16px" }}>⚠️</div>
          <h1 className="app-loading-title">SYSTEM ERROR</h1>
          <p className="app-loading-text">
            {this.state.error?.message || "Unknown error occurred"}
          </p>
          <button
            onClick={() => window.location.reload()}
            className="btn btn-primary"
            style={{ marginTop: "24px" }}
          >
            REINITIALIZE SYSTEM
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

// Get root element
const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Root element not found");
}

// Create React root with React 18 API
const root = ReactDOM.createRoot(rootElement);

// Render app
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

// Hot Module Replacement for development
if (import.meta.hot) {
  import.meta.hot.accept();
}
